import { InjectionToken } from "@angular/core";
import { LoggerConfiguracion } from "./LoggerConfiguracion";
import { ITransportador } from "./Transportador";

export enum LogTipos { ERROR, DEBUG, INFO, WARNING }

export const LoggerConfiguracionToken = new InjectionToken<LoggerConfiguracion>("LoggerConfiguracion");
export const LoggerTransportadorToken = new InjectionToken<ITransportador>("Transportadores");
